import InlineNoteWithIcon from './inline-note-with-icon';
import './inline-note-with-icon.scss';

export default InlineNoteWithIcon;
